var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 85,
    viewBox: "0 0 90 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_72736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.0344 85C58.8883 84.9821 50.7408 79.2176 47.6815 70.5986C42.6132 57.0864 53.3844 41.5631 68.0344 41.8436C96.6581 43.0212 96.6542 83.8145 68.0344 85ZM74.7975 57.0406L65.4087 66.4294L61.2713 62.292C60.6527 61.6733 59.6502 61.6714 59.0296 62.29C59.0296 62.29 59.0296 62.29 59.0276 62.292C58.407 62.9166 58.407 63.927 59.0276 64.5516L64.2789 69.803C64.9055 70.4236 65.912 70.4236 66.5386 69.803L77.0571 59.2844C77.6638 58.6479 77.642 57.6394 77.0054 57.0327C76.3868 56.4419 75.4121 56.4459 74.7975 57.0406Z",
    fill: "#53FFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1143 24.7529C24.3013 31.9794 23.0621 39.1702 20.4702 45.9173H43.3533C40.7475 39.1244 39.5083 31.8819 39.7092 24.6096C39.8047 23.259 40.3736 21.986 41.3164 21.0133C43.9003 18.1449 45.0381 14.2562 44.4036 10.447C41.4656 -4.66257 19.593 -2.88229 19.2608 12.5634C19.2509 15.6466 20.3847 18.6223 22.4434 20.9178C23.44 21.9561 24.0328 23.3167 24.1143 24.7529Z",
    fill: "#53FFCC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0.499023 60.3507V56.627C0.501013 52.4717 3.87062 49.1021 8.02594 49.1001H47.8565C44.5565 53.7288 42.9553 59.3561 43.3213 65.0291H5.16157C2.58563 65.0152 0.504991 62.9266 0.499023 60.3507Z",
    fill: "#53FFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7509 68.164C43.1144 68.2495 7.51075 68.17 6.91202 68.1958C5.74241 68.2854 4.56484 68.2197 3.41113 68.0049V69.1188C3.4171 71.6987 5.50968 73.7853 8.08959 73.7814H45.5491C44.7176 71.9911 44.1129 70.1034 43.7509 68.164Z",
    fill: "#53FFCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_72736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89.0022,
    height: 85,
    fill: "white",
    transform: "translate(0.499023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStamp);
export default __webpack_public_path__ + "static/media/Stamp.baee447bef966fae04b8d752d91638f0.svg";
export { ForwardRef as ReactComponent };